module.exports = __webpack_public_path__ + "static/media/eye.8966ccb6.png";